import BaseController from "./BaseController";
import DataService from "../util/DataService";
import { Button$PressEvent } from "sap/m/Button";

/**
 * @namespace com.reply.leaviosa.controller
 */
export default class Project extends BaseController {

    private readonly DIALOG_ID = "DialogUpdateProjectSettings";

    public async onInit(): Promise<void> {
        const oRouter = this.getOwnerComponent().getRouter();
        oRouter.getRoute("project").attachPatternMatched(this.onObjectMatched, this);
    }

    async onObjectMatched(oEvent: any): Promise<void> {
        const args = oEvent.getParameter("arguments") as { id: string };
        const data = await DataService.getProjectData(args.id);
        console.log(data);

    }

    async onUpdateProjectSettings(oEvent: Button$PressEvent): Promise<void> {
        await this.openDialog(this.DIALOG_ID);
    }

    async onSaveDialog(oEvent: Button$PressEvent): Promise<void> {
        DataService.updateProject();
        this.destroyDialog(this.DIALOG_ID);
    }

    onCloseDialog(): void {
        this.destroyDialog(this.DIALOG_ID);
    }

}
